import {Api} from '../services/Api';

const SettingsProvider = {
  getAdminAttribute : async (name) => {
    return await Api.get('/admin_settings/attribute?name=' + name);
  },
  getAttribute : async (name) => {
    return await Api.get('/settings/attribute?name=' + name);
  },
}

export default SettingsProvider;
